import { createAsyncThunk } from "@reduxjs/toolkit";
import { AnnouncementApi } from "api/announcement";
import { AnnouncementFormType } from "api/announcement/type";
import { ApplicationRootState } from "types";

export const getAnnouncement = createAsyncThunk(
  "announcement/getAnnouncement",
  async (formData: AnnouncementFormType, { rejectWithValue }) => {
    try {
      const response = await AnnouncementApi.getAnnouncement(formData);
      return { ...response.data, type: formData.type };
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

export const getHomeAnnouncement = createAsyncThunk(
  "announcement/getHomeAnnouncement",
  async (_, { rejectWithValue }) => {
    try {
      const response = await AnnouncementApi.getAnnouncement({
        page: 1,
        size: 1,
      });

      return response.data;
    } catch (error) {
      return rejectWithValue(error);
    }
  },
  {
    condition: (_, { getState }) => {
      const state = getState() as ApplicationRootState;

      if (state.announcement.isHomeLoading) return false;

      return !state.announcement.hasFetchedHomeData;
    },
  }
);
